export class RouteItem {
    public no:number
    public passInfo: string
    public time:string
    public exceptCommuterFare: number
    public check: boolean
    public commuterRegistKey: string
    public message: string
    public ifCommuteRoute: boolean
}

export class LowestInfo {
    public price: number = 0;
    public passInfo: string = '';
    public message: string = '';
}